import { Box, CardContent, CardHeader, Typography } from '@mui/material';
import { ModuleConfig } from '@schamburg-web/interfaces';
import { DisplayCard } from '@schamburg-web/lakecounty';
import { snowplowIcon } from '.';
import CardCloseButton from '../../components/CardCloseButton/CardCloseButton';
import PassageImage from '../../components/PassageImage/PassageImage';
import UpdatedTimeStamp from '../../components/UpdatedTimeStamp/UpdatedTimeStamp';
import { getLocationDescription, getNormalizedIcon } from '../utils';

const SnowplowDisplayCard: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon, module }) => {
  const normalizedIcon = getNormalizedIcon(icon);
  const { filename, heading } = normalizedIcon || {};

  return (
    <Box sx={{ maxWidth: 500, width: '100%', position: 'relative' }}>
      <DisplayCard icon={icon} module={module}>
        <CardHeader
          action={<CardCloseButton />}
          avatar={
            <Box
              component="img"
              src={snowplowIcon}
              alt="Snowplow icon"
              sx={{
                width: 40,
                height: 40,
                transform: `rotate(${heading ?? 0}deg)`,
                transition: 'transform 0.2s ease-out',
              }}
            />
          }
          title={
            <Box>
              <Typography variant="h6" fontWeight="bold">
                {normalizedIcon && normalizedIcon.location
                  ? getLocationDescription(normalizedIcon)
                  : 'Snowplow'}
              </Typography>

              <Box display="flex" alignItems="center" gap={1}>
                <UpdatedTimeStamp
                  prefix={'Location'}
                  icon={normalizedIcon}
                  fieldName="lastUpdated"
                />
              </Box>
            </Box>
          }
          slotProps={{
            title: {
              sx: {
                fontSize: '1.3rem',
                fontWeight: 'bold',
              },
            },
          }}
          sx={{ paddingBottom: 1 }}
        />

        {filename && (
          <CardContent sx={{ pt: 0 }}>
            <PassageImage
              filename={filename}
              description={getLocationDescription(normalizedIcon)}
              imageUrl={import.meta.env.VITE_REACT_APP_CAMERA_URL}
            />
          </CardContent>
        )}
      </DisplayCard>
    </Box>
  );
};

export default SnowplowDisplayCard;
